export const getDoctorTitle = (title?: string, t?: any): string => {
    if (!t || !title) return '';
    return title === 'male_doctor'
        ? t('screens.home.header.doctor_title.male')
        : t('screens.home.header.doctor_title.female');
};

export const getDoctorPronoun = (title?: string, t?: any): string => {
    if (!t) return '';
    return title === 'male_doctor'
        ? t('pronoun.male')
        : t('pronoun.female');
};
